(function (Drupal, once) {
  'use strict';

  Drupal.behaviors.checkboxDescriptionClick = {
    attach(context) {
      const descriptions = once('checkbox-description-click', '.js-form-type-checkbox .description', context);

      descriptions.forEach(desc => {
        const wrapper = desc.closest('.js-form-item');
        const checkbox = wrapper?.querySelector('input[type="checkbox"]');
        if (!checkbox) return;

        if (!desc.hasAttribute('tabindex')) {
          desc.setAttribute('tabindex', '0');
        }

        const handleInteraction = (e) => {
          if (e.target.closest('a') || e.target.closest('label') || checkbox.disabled) return;

          if (e.type === 'click' || e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
            e.preventDefault();
            checkbox.click();
          }
        };

        desc.addEventListener('click', handleInteraction);
        desc.addEventListener('keydown', handleInteraction);

        // Store bound handlers for cleanup
        desc._checkboxHandlers = handleInteraction;
      });
    },

    detach(context, settings, trigger) {
      if (trigger !== 'unload') return;

      const descriptions = once.filter('checkbox-description-click', '.js-form-type-checkbox .description', context);

      descriptions.forEach(desc => {
        if (desc._checkboxHandlers) {
          desc.removeEventListener('click', desc._checkboxHandlers);
          desc.removeEventListener('keydown', desc._checkboxHandlers);
          delete desc._checkboxHandlers;
        }
      });

      once.remove('checkbox-description-click', descriptions);
    }
  };

})(Drupal, once);
